export default "__VITE_PUBLIC_ASSET__a3456a7b__"